import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy, } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'src/app/core/services/cookie.service';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';
import { AddSocietyComponent } from '../add-society/add-society.component';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-add-property',
  templateUrl: './add-property.component.html',
  styleUrls: ['./add-property.component.scss']
})
export class AddPropertyComponent implements OnInit, OnDestroy {
  breadCrumbItems: Array<{}>;
  property: FormGroup;
  submitted: boolean;
  currentUser: any;
  notfoundshow: boolean;
  isLoading: boolean;
  isLoading1: boolean;
  /* Safety timer: guarantees the edit-prefill loader can never stay stuck
     forever if some async branch fails to reach completion. */
  private editLoadTimer: any = null;
  keyword = 'name';
  keyword1 = 'Area'
  areas: any;
  propertyType: any;
  bankList: any;
  UserID: any;
  PropertyId: any;
  initialValue = '';
  loanTypes: any;
  DistrictList: any;
  
  propStates: any[] = [];
  propBaseDocTypes: any[] = [];
  propStateID: any = null;
  propBaseDocTypeID: any = null;
  propFieldsData: any[] = [];
  propDataList: any = {};
  propDynamicNotice: FormGroup;
  isPropDynLoading = false;

  selectedDistrictId: number = null;
  selectedDistrictName: string = null;
  selectedSourceField: string = null;

  StateList: any[];
  baseDocType: any;
  date: Date = new Date();
  fieldsData: any[];
  DataList: any = {};
  URL: string;
  dynamicFields = [];
  stateID: any;
  isImageUploaded = false;
  StateBaseDocType: any;
  param: string;
  PropertyData: any;
  Editproperty: boolean;
  Type: any;
  // cl: boolean
  // op: boolean
  societylist: any;
  selectedLandType: string = 'OpenLand';
  showmsg: boolean = false;
  /* True when the required location (Village/Pincode or Ward) is empty. */
  locationMissing: boolean = false;
  id: any;
  constructor(private service: GeneralService, public dialog: MatDialog, private Fb: FormBuilder, private router: Router) {
    let a = this.router.getCurrentNavigation().extras;
    if (a && a.state) {
      if (a.state.Editproperty === true) {
        this.Editproperty = true;
        this.UserID = a.state.editId
        this.PropertyId = a.state.rowid
        console.log("Cons Propertyid", this.PropertyId)
        console.log("Cons UserID", this.UserID)
        localStorage.setItem('edit', 'true')
        localStorage.setItem("PropertyID", this.PropertyId)
        localStorage.setItem("editId", this.UserID)
      } else {
        this.Editproperty = false;
        this.UserID = a.state.id
        localStorage.setItem('edit', 'false')
        localStorage.setItem('id', this.UserID)
      }
    } else {
      // Page refresh: no navigation state, restore the last mode.
      this.Editproperty = localStorage.getItem('edit') === 'true';
      if (this.Editproperty) {
        this.PropertyId = localStorage.getItem('PropertyID');
        this.UserID = localStorage.getItem('editId');
      }
    }
    if (!this.UserID && localStorage.getItem('id')) {
      this.UserID = localStorage.getItem('id')
    }
    if (this.Editproperty == true) {
      this.Type = 'edit'
      this.breadCrumbItems = [
        { label: 'Property', path: '/users/view-property' },
        { label: 'Edit Property', path: '/', active: true },
      ];
    }
    else {
      this.breadCrumbItems = [
        { label: 'Property', path: '/users/view-property' },
        { label: 'Add Property', path: '/', active: true },
      ];
    }
    console.log("userid", this.UserID)
  }

  ngOnInit() {
    this.currentUser = this.service.currentUser();
    console.log('current User', this.currentUser)

    this.submitted = false;
    this.property = this.Fb.group({
      propState: new FormControl(null),
      propBaseDocType: new FormControl(null),
      VillageID: new FormControl(null),
      DistrictID: new FormControl(null),
      villageid: new FormControl(null),
      districtname: new FormControl(null),
      villagename: new FormControl(null),
      Talukaname: new FormControl(null),
      TalukaID: new FormControl(null),
      CityWardNo: new FormControl(null),
      CitySurveyOfficeID: new FormControl(null),
      CitySurveyOfficeName: new FormControl(null),
      WardName: new FormControl(null),
      SurveyNo: new FormControl(null),
      TPNo: new FormControl(null),
      FPNo: new FormControl(null),
      Society: new FormControl(null),
      SocietyName: new FormControl(null),
      BuildingNo: new FormControl(null),
      UserID: new FormControl(this.UserID),
      csrId: new FormControl(this.currentUser.Id),
    })

    this.propDynamicNotice = this.Fb.group({});
    this.property.addControl('propDynamicNotice', this.propDynamicNotice);
    this.loadPropStates();

    // Edit mode: fetch the saved record only after the form groups exist,
    // so setNoticeData always has controls to patch.
    if (this.Type != undefined && this.UserID != undefined) {
      this.getNoticeData(this.PropertyId);
    }

    // this.validation();
    this.getDistrict()
  }

  loadPropStates() {
    this.service.getState().subscribe((res: any) => {
      this.propStates = res.data;
    });
  }

  onPropStateChange(stateVal: any) {
    this.propStateID = stateVal;
    this.propBaseDocTypeID = null;
    this.propBaseDocTypes = [];
    this.property.get('propBaseDocType').setValue(null, { emitEvent: false });
    this.resetPropDynamicSystem();

    if (stateVal) {
      this.service.getStateBaseDocTypeByStateID(stateVal).subscribe((res: any) => {
        this.propBaseDocTypes = res.data;
      });
    }
  }

  onPropBaseDocTypeChange(docTypeID: any, afterLoad?: () => void) {
    if (!docTypeID) {
      this.propBaseDocTypeID = null;
      this.resetPropDynamicSystem();
      return;
    }

    this.propBaseDocTypeID = docTypeID;
    this.resetPropDynamicSystem();

    const displayLevel = this.selectedLandType === 'OpenLand' ? '1' : '2';

    const params = new URLSearchParams({
      StateID: this.propStateID,
      Service_subtype_id: '2',
      StateBaseDocTypeID: String(docTypeID),
      DisplayLevel: displayLevel,
    });

    this.isPropDynLoading = true;

    this.service.getDynamicFields(params.toString()).subscribe((res: any) => {
      this.isPropDynLoading = false;
      const allFields: any[] = res.data || [];

      if (this.selectedLandType === 'OpenLand') {
        this.propFieldsData = allFields.filter(
          (f) =>
            f.DBColumnName !== 'BuildingNo' &&
            f.DBColumnName !== 'BuildingName'
        );
      } else {
        
        this.propFieldsData = allFields;
      }

      this.propFieldsData.forEach((field) => {
        // Constructed Land: Society (BuildingName) and Building No are ALWAYS
        // required for Rural / Urban / Both, regardless of the dynamic config.
        // Setting IsMandatory drives both the "*" in the label and the validator.
        if (this.selectedLandType === 'ConstructedLand' &&
          (field.DBColumnName === 'BuildingName' || field.DBColumnName === 'BuildingNo')) {
          field.IsMandatory = true;
        }

        this.propDynamicNotice.addControl(
          field.DBColumnName,
          this.Fb.control(null, field.IsMandatory ? Validators.required : null)
        );

        if (field.FieldType === 'Text') return;

        if (field.FieldType === 'AutoComplete') {
          this.propDataList[field.DBColumnName] = [];
          return;
        }

        if (field.FieldType === 'Dropdown' && field.APIName) {
          let url = field.APIName;
          if (url.endsWith('/')) url += this.propStateID;
          if (url.includes('http')) {
            this.service.dynamicData(url).subscribe((resp: any) => {
              this.propDataList[field.DBColumnName] = resp.data || [];
            });
          }
        }
      });

      // Edit mode: dynamic controls now exist, prefill their saved values.
      if (afterLoad) {
        afterLoad();
      }
    });
  }

  getPropDynamicFieldPayload() {
    const result: any = {};

    this.propFieldsData.forEach((field) => {
      const ctrl = this.propDynamicNotice.get(field.DBColumnName);
      if (!ctrl) return;

      const value = ctrl.value;
      if (value === null || value === undefined || value === '') return;

      
      switch (field.DBColumnName) {
        case 'VillageID':
          result['villageid'] = value;
          break;
        case 'CityWardNo':
          result['CityWardNo'] = value;
          break;
        // Survey identifiers always go to the API with English digits, even
        // if a Gujarati-numeral value slipped past validation() (e.g. the
        // Constructed Land branch, which clears the survey validators).
        case 'SurveyNo':
          result['SurveyNo'] = this.toEnglishDigits(value);
          break;
        case 'TPNo':
          result['TPNo'] = this.toEnglishDigits(value);
          break;
        case 'FPNo':
          result['FPNo'] = this.toEnglishDigits(value);
          break;
        case 'BuildingName': {
          // The select is bound to the society ID; the backend stores the ID
          // in `society` (req.body.Society) and only uses SocietyName for the
          // notification e-mail — send both.
          result['Society'] = value;
          const soc = (this.propDataList['BuildingName'] || []).find(
            (s: any) => s.ID == value
          );
          if (soc) { result['SocietyName'] = soc.Name; }
          break;
        }
        case 'BuildingNo':
          // Constructed Land: Building No goes to the API with English digits too.
          result['BuildingNo'] = this.toEnglishDigits(value);
          break;
        default:
          result[field.DBColumnName] = value;
          break;
      }
    });

    return result;
  }



  resetPropDynamicSystem() {
    this.propFieldsData = [];
    this.propDataList = {};

    Object.keys(this.propDynamicNotice.controls).forEach((ctrl) => {
      this.propDynamicNotice.removeControl(ctrl);
    });

    this.propDynamicNotice.markAsPristine();
    this.propDynamicNotice.markAsUntouched();
    this.propDynamicNotice.updateValueAndValidity();
  }

  onPropSearchField(search: string, field: any) {
    if (!search || search.length < 3) {
      this.propDataList[field.DBColumnName] = [];
      return;
    }

    if (!this.propStateID) {
      Swal.fire({ title: 'Error', text: 'Please Select State', type: 'error' });
      return;
    }

    this.service
      .areabystateid(field.APIName, search)
      .pipe(first())
      .subscribe((res: any) => {
        if (res.error) return;

        let data = res.data || [];

        // ── Strict district-rights filter ──────────────────────────────
        // Only surface Village/Ward records that fall inside the districts
        // this user has active rights to. When the rights list is loaded but
        // empty, the user has no districts → show nothing.
        const allowedDistrictIds = this.getAllowedDistrictIds();
        if (allowedDistrictIds !== null) {
          data = data.filter(x => allowedDistrictIds.has(Number(x.DistrictId)));
        }

        // Keep Village and Ward consistent within the same form: once one is
        // chosen, restrict the other to that same district.
        if (this.selectedDistrictId) {
          data = data.filter(x =>
            x.DistrictId == this.selectedDistrictId
          );
        }

        this.propDataList[field.DBColumnName] = data.map((item) => ({
          ...item,
          AreaId: item.VillageId || item.WardID,
          AreaName: item.Area || item.WardName || item.VillageName,
        }));
      });
  }



  getNoticeData(id) {
    console.log("id", id)
    this.isLoading = true;

    /* Keep the loader visible for the WHOLE prefill chain (fetch → state base
       doc types → dynamic fields → prefill). It is turned off only once the
       form is fully populated, via finishEditLoad(). A safety timer force-hides
       it after 20s so a failed branch can never leave the loader stuck. */
    if (this.editLoadTimer) { clearTimeout(this.editLoadTimer); }
    this.editLoadTimer = setTimeout(() => { this.isLoading = false; }, 20000);

    if (this.Type === 'edit') {
      this.service.FetchProperty(id, this.UserID).subscribe(
        (res) => {
          this.setNoticeData(res)
          console.log('Edit Noticedata', res)
        },
        (err) => {
          console.log('FetchProperty failed', err);
          this.finishEditLoad();   // hide loader on fetch error
        }
      )
    } else {
      this.finishEditLoad();
    }
  }

  /* Ends the edit-prefill loading state and clears the safety timer.
     Called from every completion / early-exit / error path of the prefill. */
  private finishEditLoad() {
    if (this.editLoadTimer) { clearTimeout(this.editLoadTimer); this.editLoadTimer = null; }
    this.isLoading = false;
  }

  ngOnDestroy() {
    if (this.editLoadTimer) { clearTimeout(this.editLoadTimer); this.editLoadTimer = null; }
  }
  setNoticeData(data: any) {
    const rows: any[] = (data && data.result) || [];
    // FetchProperty filters with a SQL LIKE on the id, so more than one row can
    // come back — pick the exact record being edited.
    const p = rows.find((r) => String(r.id) === String(this.PropertyId)) || rows[0];
    if (!p) { this.finishEditLoad(); return; }
    this.PropertyData = p;

    // Land type is derived from the saved record.
    const hasSociety = (p.society && p.society != 0) || this.renderData(p.societyname) !== null;
    const hasBuildingNo = this.renderData(p.buildingno) !== null;
    this.selectedLandType = (hasSociety || hasBuildingNo) ? 'ConstructedLand' : 'OpenLand';

    // Urban rows come back with the ward name in `villagename` and the city
    // survey office name in `Talukaname` (COALESCE in the GET query), so split
    // them back apart before mirroring onto the form.
    const wardId = this.pick(p, ['WardID', 'wardid', 'wardID', 'CityWardNo', 'ward']);
    const isUrbanOnly = !!wardId && this.renderData(p.village) === null;
    if (isUrbanOnly) {
      p.WardName = this.pick(p, ['WardName', 'wardname']) || p.villagename;
      p.CitySurveyOfficeName = this.pick(p, ['CitySurveyOfficeName', 'citysurveyofficename']) || p.Talukaname;
      p.villagename = null;
      p.Talukaname = null;
    }

    // Mirror the base location values onto the parent form group. These are
    // consumed by save() when building the final payload (district/taluka/
    // village names + ids, ward), independent of the dynamic controls.
    this.property.patchValue({
      DistrictID: p.district,
      districtname: p.districtname,
      TalukaID: isUrbanOnly ? null : p.taluka,
      Talukaname: p.Talukaname,
      villageid: this.renderData(p.village),
      villagename: p.villagename,
      CityWardNo: wardId || null,
      WardName: this.pick(p, ['WardName', 'wardname']) || null,
      CitySurveyOfficeID: this.pick(p, ['CitySurveyOfficeID', 'citysurveyofficeid']) || null,
      CitySurveyOfficeName: this.pick(p, ['CitySurveyOfficeName', 'citysurveyofficename']) || null,
      Society: this.renderData(p.society),
      SocietyName: this.renderData(p.societyname),
    });

    // State + Base Document Type drive the dynamic field set. The GET endpoint
    // returns them as StateID / BaseDocumentType_Dynamic; the backend also
    // defaults StateID to 7 for property-protection rows, so fall back to that.
    const stateId = this.pick(p, ['PropStateID', 'propstateid', 'StateID', 'stateid', 'state']) || 7;
    const bdtId = this.pick(p, ['PropBaseDocTypeID', 'propbasedoctypeid', 'BaseDocumentType_Dynamic', 'StateBaseDocTypeID', 'statebasedoctypeid', 'basedoctypeid']);

    this.propStateID = stateId;
    this.property.get('propState').setValue(stateId, { emitEvent: false });

    this.service.getStateBaseDocTypeByStateID(stateId).subscribe(
      (res: any) => {
        this.propBaseDocTypes = res.data || [];

        const known = bdtId && this.propBaseDocTypes.some((b) => b.ID == bdtId);
        if (known) {
          this.propBaseDocTypeID = bdtId;
          this.property.get('propBaseDocType').setValue(bdtId, { emitEvent: false });
          // Load the dynamic fields for this state/BDT/land-type, then prefill,
          // and only THEN hide the loader — the form is now fully populated.
          this.onPropBaseDocTypeChange(bdtId, () => {
            this.prefillDynamicFromProperty(p);
            this.finishEditLoad();
          });
        } else {
          // Rows added from this module never persist a base doc type (the add
          // stored procedure ignores it), so infer it from the record's shape.
          this.inferBaseDocTypeAndPrefill(p, wardId);
        }
      },
      (err) => {
        console.log('getStateBaseDocTypeByStateID failed', err);
        this.finishEditLoad();   // hide loader on error
      }
    );

    console.log('PropertyData', p);
  }

  /**
   * Edit mode fallback: the saved record carries no usable base document type,
   * so probe the dynamic field set of every doc type of the state and pick the
   * one whose village/ward fields match what the record actually holds.
   */
  inferBaseDocTypeAndPrefill(p: any, wardId: any) {
    const candidates = this.propBaseDocTypes || [];
    if (!candidates.length || !this.propStateID) { this.finishEditLoad(); return; }

    const hasVillage = this.renderData(p.village) !== null;
    const hasWard = !!wardId;
    const displayLevel = this.selectedLandType === 'OpenLand' ? '1' : '2';

    // Tie-breaker: at DisplayLevel 1 the Dynamicdata API returns the SAME
    // field set for "Rural" and "Both" (VillageID/SurveyNo/TPNo/FPNo), so the
    // field-shape score alone cannot separate them. Prefer the doc type whose
    // name matches the record's shape so the choice does not depend on which
    // HTTP response happens to arrive first (that race made a Rural record
    // open as "Both" on first navigation but "Rural" after a reload).
    const preferredName = hasVillage && hasWard ? 'both' : (hasWard ? 'urban' : 'rural');
    const nameOf = (bdt: any) => String(bdt.Name || bdt.BaseDocType || '').trim().toLowerCase();

    // Score every candidate first, then decide once ALL responses are in, so
    // the outcome is independent of response ordering.
    const scores: { [id: string]: number } = {};
    let pending = candidates.length;

    const finish = () => {
      let bestId = null;
      let bestScore = -1;
      candidates.forEach((bdt) => {
        const score = scores[bdt.ID] !== undefined ? scores[bdt.ID] : -1;
        // Strict ">" + iterating in list order keeps ties deterministic.
        if (score > bestScore) { bestScore = score; bestId = bdt.ID; }
      });
      const chosen = bestId != null ? bestId : candidates[0].ID;
      this.propBaseDocTypeID = chosen;
      this.property.get('propBaseDocType').setValue(chosen, { emitEvent: false });
      this.onPropBaseDocTypeChange(chosen, () => {
        this.prefillDynamicFromProperty(p);
        this.finishEditLoad();   // form fully populated → hide loader
      });
    };

    candidates.forEach((bdt) => {
      const params = new URLSearchParams({
        StateID: String(this.propStateID),
        Service_subtype_id: '2',
        StateBaseDocTypeID: String(bdt.ID),
        DisplayLevel: displayLevel,
      });
      this.service.getDynamicFields(params.toString()).subscribe(
        (res: any) => {
          const cols = (res.data || []).map((f: any) => f.DBColumnName);
          let score = 0;
          if (hasVillage === cols.includes('VillageID')) { score++; }
          if (hasWard === cols.includes('CityWardNo')) { score++; }
          // Half a point so the name only ever breaks a tie between
          // candidates with an identical field-shape score.
          if (nameOf(bdt) === preferredName) { score += 0.5; }
          scores[bdt.ID] = score;
          if (--pending === 0) { finish(); }
        },
        () => { if (--pending === 0) { finish(); } }
      );
    });
  }

  /** Returns the first defined/non-null value among the given keys. */
  pick(obj: any, keys: string[]) {
    if (!obj) { return null; }
    for (const k of keys) {
      if (obj[k] !== undefined && obj[k] !== null && obj[k] !== '' && obj[k] !== 'null') {
        return obj[k];
      }
    }
    return null;
  }

  /** Edit mode: populate the dynamic controls (and their display lists) from a saved property record. */
  prefillDynamicFromProperty(p: any) {
    const dyn = this.propDynamicNotice;

    // Village / Pincode (AutoComplete) — seed the item list so the label renders.
    if (dyn.get('VillageID') && p.village) {
      const label = [p.villagename, p.Talukaname, p.districtname].filter(Boolean).join(', ');
      this.propDataList['VillageID'] = [{
        AreaId: p.village,
        AreaName: label,
        VillageId: p.village,
        VillageName: p.villagename,
        TalukaId: p.taluka,
        TalukaName: p.Talukaname,
        DistrictId: p.district,
        DistrictName: p.districtname,
      }];
      dyn.get('VillageID').setValue(p.village);
      this.selectedDistrictId = p.district || null;
      this.selectedDistrictName = p.districtname || null;
      this.selectedSourceField = 'VillageID';
    }

    // Ward (AutoComplete) — urban records. Independent of the village above, so
    // a "Both" property prefills both the village and the ward.
    const wardId = this.pick(p, ['WardID', 'wardid', 'wardID', 'CityWardNo', 'ward']);
    if (dyn.get('CityWardNo') && wardId) {
      const wardName = this.pick(p, ['WardName', 'wardname']);
      const csoId = this.pick(p, ['CitySurveyOfficeID', 'citysurveyofficeid']);
      const csoName = this.pick(p, ['CitySurveyOfficeName', 'citysurveyofficename']);
      this.propDataList['CityWardNo'] = [{
        AreaId: wardId,
        AreaName: [wardName || ('Ward ' + wardId), csoName, p.districtname].filter(Boolean).join(', '),
        WardID: wardId,
        WardName: wardName,
        CitySurveyOfficeID: csoId,
        CitySurveyOfficeName: csoName,
        DistrictId: p.district,
        DistrictName: p.districtname,
      }];
      dyn.get('CityWardNo').setValue(wardId);
      if (!this.selectedDistrictId) {
        this.selectedDistrictId = p.district || null;
        this.selectedDistrictName = p.districtname || null;
        this.selectedSourceField = 'CityWardNo';
      }
    }

    // Plain text survey identifiers. Saved values may contain Gujarati
    // numerals (e.g. "2p૧૧"); normalise them to English digits so the
    // pattern validators in validation() accept the prefilled record.
    if (dyn.get('SurveyNo')) { dyn.get('SurveyNo').setValue(this.renderIdentifier(p.surveyno)); }
    if (dyn.get('TPNo')) { dyn.get('TPNo').setValue(this.renderIdentifier(p.tpno)); }
    if (dyn.get('FPNo')) { dyn.get('FPNo').setValue(this.renderIdentifier(p.fpno)); }

    // Constructed land: society dropdown + building number. Building No gets
    // the same Gujarati→English digit normalisation as the survey identifiers.
    if (dyn.get('BuildingNo')) { dyn.get('BuildingNo').setValue(this.renderIdentifier(p.buildingno)); }
    if (dyn.get('BuildingName') && p.society && p.society != 0) {
      // Seed with the saved society so it renders immediately, then refresh the
      // full list — keeping the saved entry in case the refresh doesn't return it.
      const saved = { ID: p.society, Name: p.societyname };
      const mergeSaved = (list: any[]) =>
        (list || []).some((s: any) => s.ID == saved.ID) ? list : [saved, ...(list || [])];
      this.propDataList['BuildingName'] = [saved];
      dyn.get('BuildingName').setValue(p.society);
      // Mirror onto the parent form so save() has the ID even if untouched.
      this.property.controls.Society.setValue(p.society);
      this.property.controls.SocietyName.setValue(p.societyname);
      if (wardId) {
        this.service.SocietylistUrban(wardId).subscribe((res: any) => {
          this.propDataList['BuildingName'] = mergeSaved(res.data);
        });
      } else if (p.village) {
        this.service.Societylist(p.village).subscribe((res: any) => {
          this.propDataList['BuildingName'] = mergeSaved(res.data);
        });
      }
    }

    // Any remaining dynamic field (Khata No, City Survey No, ...) — match its
    // DB column against the record's keys ignoring case and underscores, since
    // the GET endpoint's aliases differ (e.g. city_survey_no vs CitySurveyNo).
    const findVal = (col: string) => {
      const norm = col.replace(/_/g, '').toLowerCase();
      for (const k of Object.keys(p)) {
        if (k.replace(/_/g, '').toLowerCase() === norm) {
          return this.renderData(p[k]);
        }
      }
      return null;
    };
    this.propFieldsData.forEach((field) => {
      // BuildingName is an ID-bound select handled above — the record's raw
      // BuildingName text must not be pushed into it.
      if (field.DBColumnName === 'BuildingName') { return; }
      const ctrl = dyn.get(field.DBColumnName);
      if (!ctrl || ctrl.value !== null) { return; }
      const val = findVal(field.DBColumnName);
      if (val !== null) { ctrl.setValue(val); }
    });

    dyn.updateValueAndValidity();
  }
  getDistrict() {
    this.service.getDistrictlist(this.UserID).subscribe((res: any) => {
      // Districts (village/taluka rows) this user actually has rights to
      // (user_district, status='active'). Used to restrict the Village/Ward
      // autocompletes — see getAllowedDistrictIds() / onPropSearchField().
      this.DistrictList = res.data || [];
    })
  }

  /**
   * Set of district IDs the current user is allowed to pick from.
   * Returns null when the rights list has not loaded yet (so callers can tell
   * "not loaded" apart from "loaded but empty").
   */
  private getAllowedDistrictIds(): Set<number> | null {
    if (!Array.isArray(this.DistrictList)) { return null; }
    const ids = new Set<number>();
    this.DistrictList.forEach((d: any) => {
      const id = this.pick(d, ['DistrictID', 'DistrictId', 'districtid', 'district']);
      if (id !== null) { ids.add(Number(id)); }
    });
    return ids;
  }
  addSociety() {
    const dialogRef = this.dialog.open(AddSocietyComponent, {
      width: '470px',
      autoFocus: false,
      maxHeight: '500px',
      data: {
        UserID: this.UserID
      },
      disableClose: false,
      position: { right: '10vh', top: '20vh' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.SocietyList(this.id)
      }
    })
  }

  toggleFields(value: string, event?: any) {
    this.selectedLandType = value;

    if (this.selectedLandType === 'ConstructedLand') {
      this.showmsg = false;
    }

    // Re-fetch with correct DisplayLevel if state + doctype already chosen
    if (this.propStateID && this.propBaseDocTypeID) {
      this.onPropBaseDocTypeChange(this.propBaseDocTypeID);
    }
  }


  resetFields() {
    this.submitted = false;
    this.showmsg = false;
    this.isLoading = true;
    this.societylist = [];
    this.property.controls.VillageID.setValue(null);
    this.property.controls.DistrictID.setValue(null);
    this.property.controls.TalukaID.setValue(null);
    this.property.controls.villageid.setValue(null);
    this.property.controls.FPNo.setValue(null);
    this.property.controls.TPNo.setValue(null);
    this.property.controls.SurveyNo.setValue(null);
    this.property.controls.Society.setValue(null);
    this.property.controls.BuildingNo.setValue(null);
    this.property.get('FPNo').clearValidators();
    this.property.get('FPNo').updateValueAndValidity();
    this.property.get('TPNo').clearValidators();
    this.property.get('TPNo').updateValueAndValidity();
    this.property.get('SurveyNo').clearValidators();
    this.property.get('SurveyNo').updateValueAndValidity();
    this.property.get('SocietyName').clearValidators();
    this.property.get('SocietyName').updateValueAndValidity();
    this.property.get('BuildingNo').clearValidators();
    this.property.get('BuildingNo').updateValueAndValidity();
    this.selectedDistrictId = null;
    this.selectedDistrictName = null;
    this.selectedSourceField = null;

    this.propStateID = null;
    this.propBaseDocTypeID = null;
    this.propBaseDocTypes = [];
    this.resetPropDynamicSystem();
    this.property.get('propState').setValue(null);
    this.property.get('propBaseDocType').setValue(null);

    this.isLoading = false;
    // this.property.controls.villageid.setValue(null);
    // this.property.reset()
  }
  SocietyList(id) {
    this.id = id
    if (id === null) {
      this.societylist = []
    } else {
      this.service.Societylist(id).subscribe((res: any) => {
        this.societylist = res.data
        console.log('society', this.societylist)
      })
    }
  }
  /** Dynamic BuildingName select changed — mirror society ID + name onto the parent form. */
  onPropSocietySelected(item: any) {
    this.property.controls.Society.setValue(item ? item.ID : null);
    this.property.controls.SocietyName.setValue(item ? item.Name : null);
  }
  selecEvnet(e) {
    console.log('socieyt even', e)
    this.property.controls.Society.setValue(e.ID)
    this.property.controls.SocietyName.setValue(e.Name)
  }
  selectEvent(item: any) {
    console.log("item", item)
    const area = item.area.split(',');
    if (item === undefined) {
      this.societylist = [];
    } else {
      if (item.DistrictID) {
        this.property.controls.DistrictID.setValue(item.DistrictID)
        this.property.controls.districtname.setValue(area[2])
      }
      if (item.TalukaID) {
        this.property.controls.TalukaID.setValue(item.TalukaID)
        this.property.controls.villagename.setValue(area[0])
      }
      if (item.villageid) {
        this.property.controls.villageid.setValue(item.villageid)
        this.property.controls.Talukaname.setValue(area[1])
      }
      this.societylist = [];
      this.property.controls.SocietyName.setValue(null)
      this.SocietyList(item.villageid)
    }
  }
  get f() { return this.property.controls; }
  checkValue() {
    // // this.validation();
    // if (this.property.controls.SurveyNo.value !== null) {
    //   this.showmsg = false;
    // }
    // if (this.property.controls.TPNo.value !== null || this.property.controls.FPNo.value !== null) {
    //   this.showmsg = false;
    // }

    const surveyNoCtrl = this.propDynamicNotice.get('SurveyNo');
    const tpNoCtrl = this.propDynamicNotice.get('TPNo');
    const fpNoCtrl = this.propDynamicNotice.get('FPNo');

    if (surveyNoCtrl && surveyNoCtrl.value !== null) {
      this.showmsg = false;
    }
    if (
      (tpNoCtrl && tpNoCtrl.value !== null) ||
      (fpNoCtrl && fpNoCtrl.value !== null)
    ) {
      this.showmsg = false;
    }

  }

  validation() {
    console.log('slected type', this.selectedLandType);

    /* ── Location is ALWAYS required ────────────────────────────────────
       Regardless of the IsMandatory flags coming from the Dynamicdata API,
       a property must have a location. Depending on the base doc type the
       location control is Village/Pincode (VillageID), Ward (CityWardNo),
       or both. Block the save if the doc type exposes a location field but
       none is selected. */
    const villageCtrl = this.propDynamicNotice.get('VillageID');
    const wardCtrl = this.propDynamicNotice.get('CityWardNo');
    const villageVal = villageCtrl ? this.renderData(villageCtrl.value) : null;
    const wardVal = wardCtrl ? this.renderData(wardCtrl.value) : null;

    if ((villageCtrl || wardCtrl) && villageVal === null && wardVal === null) {
      this.locationMissing = true;
      this.showmsg = true;
      return;
    }
    this.locationMissing = false;

    if (this.selectedLandType === 'OpenLand') {
      console.log('this.messgae', this.showmsg);

      
      const surveyNoCtrl = this.propDynamicNotice.get('SurveyNo');
      const tpNoCtrl = this.propDynamicNotice.get('TPNo');
      const fpNoCtrl = this.propDynamicNotice.get('FPNo');
      const villageCtrl = this.propDynamicNotice.get('VillageID');

      // If dynamic fields not loaded yet, skip validation
      if (!surveyNoCtrl && !tpNoCtrl && !fpNoCtrl) {
        this.showmsg = false;
        return;
      }

      // Normalise Gujarati numerals to English digits before the ASCII-only
      // pattern validators run (covers both prefilled and freshly typed values).
      [surveyNoCtrl, tpNoCtrl, fpNoCtrl].forEach((ctrl) => {
        if (ctrl && typeof ctrl.value === 'string') {
          const normalised = this.toEnglishDigits(ctrl.value);
          if (normalised !== ctrl.value) { ctrl.setValue(normalised, { emitEvent: false }); }
        }
      });

      const surveyNo = this.renderData(surveyNoCtrl ? surveyNoCtrl.value : null);
      const tpno = this.renderData(tpNoCtrl ? tpNoCtrl.value : null);
      const fpno = this.renderData(fpNoCtrl ? fpNoCtrl.value : null);
      const Village = this.renderData(villageCtrl ? villageCtrl.value : null);

      if (Village !== null) {
        if (surveyNo === null && tpno === null && fpno === null) {
          return this.showmsg = true;
        } else if (surveyNo !== null && tpno === null && fpno === null) {
          surveyNoCtrl.setValue(surveyNoCtrl.value.trim());
          surveyNoCtrl.setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9\\-+/\\.]*$')]);
          surveyNoCtrl.updateValueAndValidity();
          return this.showmsg = false;
        } else if (surveyNo === null && tpno !== null && fpno === null) {
          tpNoCtrl.setValue(tpNoCtrl.value.trim());
          fpNoCtrl.setValidators([Validators.required, Validators.pattern('^[A-Za-z0-9/+\\-]+$')]);
          fpNoCtrl.updateValueAndValidity();
          return this.showmsg = false;
        } else if (surveyNo !== null && tpno !== null && fpno === null) {
          surveyNoCtrl.setValue(surveyNoCtrl.value.trim());
          tpNoCtrl.setValue(tpNoCtrl.value.trim());
          surveyNoCtrl.setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9\\-+/\\.]*$')]);
          surveyNoCtrl.updateValueAndValidity();
          tpNoCtrl.setValidators([Validators.required, Validators.pattern('^[A-Za-z0-9/+\\-]+$')]);
          tpNoCtrl.updateValueAndValidity();
          return this.showmsg = false;
        } else if (surveyNo !== null && tpno === null && fpno !== null) {
          surveyNoCtrl.setValue(surveyNoCtrl.value.trim());
          fpNoCtrl.setValue(fpNoCtrl.value.trim());
          surveyNoCtrl.setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9\\-+/\\.]*$')]);
          surveyNoCtrl.updateValueAndValidity();
          fpNoCtrl.setValidators([Validators.required, Validators.pattern('^[A-Za-z0-9/+\\-]+$')]);
          fpNoCtrl.updateValueAndValidity();
          return this.showmsg = false;
        } else if (surveyNo === null && tpno === null && fpno !== null) {
          fpNoCtrl.setValue(fpNoCtrl.value.trim());
          tpNoCtrl.setValidators([Validators.required, Validators.pattern('^[A-Za-z0-9/+\\-]+$')]);
          tpNoCtrl.updateValueAndValidity();
          return this.showmsg = false;
        } else if (surveyNo !== null && tpno !== null && fpno !== null) {
          surveyNoCtrl.setValue(surveyNoCtrl.value.trim());
          tpNoCtrl.setValue(tpNoCtrl.value.trim());
          fpNoCtrl.setValue(fpNoCtrl.value.trim());
          if (
            surveyNoCtrl.value === '' &&
            tpNoCtrl.value === '' &&
            fpNoCtrl.value === ''
          ) {
            return this.showmsg = true;
          } else {
            return this.showmsg = false;
          }
        } else if (surveyNo === null && tpno !== null && fpno !== null) {
          tpNoCtrl.setValue(tpNoCtrl.value.trim());
          fpNoCtrl.setValue(fpNoCtrl.value.trim());
          tpNoCtrl.setValidators([Validators.required, Validators.pattern('^[A-Za-z0-9/+\\-]+$')]);
          tpNoCtrl.updateValueAndValidity();
          fpNoCtrl.setValidators([Validators.required, Validators.pattern('^[A-Za-z0-9/+\\-]+$')]);
          fpNoCtrl.updateValueAndValidity();
          return this.showmsg = false;
        }
      }

      
      const socCtrl = this.propDynamicNotice.get('BuildingName');
      const buildingCtrl = this.propDynamicNotice.get('BuildingNo');
      if (socCtrl) { socCtrl.clearValidators(); socCtrl.updateValueAndValidity(); }
      if (buildingCtrl) { buildingCtrl.clearValidators(); buildingCtrl.updateValueAndValidity(); }

    } else {

      this.showmsg = false;

      const socCtrl = this.propDynamicNotice.get('BuildingName');
      const buildingCtrl = this.propDynamicNotice.get('BuildingNo');

      /* Respect the IsMandatory flags from the Dynamicdata API — the required
         validators (if any) were already applied when the controls were created
         in onPropBaseDocTypeChange(). Do NOT force Society/BuildingNo required
         here; the API currently marks them IsMandatory:false. Only the location
         check above is enforced as a hard rule. */

      if (buildingCtrl && buildingCtrl.value) {
        // Trim + Gujarati→English digits, mirroring the Open Land survey fields.
        buildingCtrl.setValue(this.toEnglishDigits(String(buildingCtrl.value).trim()));
      }

      
      const surveyNoCtrl = this.propDynamicNotice.get('SurveyNo');
      const tpNoCtrl = this.propDynamicNotice.get('TPNo');
      const fpNoCtrl = this.propDynamicNotice.get('FPNo');
      if (surveyNoCtrl) { surveyNoCtrl.clearValidators(); surveyNoCtrl.updateValueAndValidity(); }
      if (tpNoCtrl) { tpNoCtrl.clearValidators(); tpNoCtrl.updateValueAndValidity(); }
      if (fpNoCtrl) { fpNoCtrl.clearValidators(); fpNoCtrl.updateValueAndValidity(); }
    }
  }

  renderData(data) {
    if (data === '' || data === null || data === 'null' || data == undefined) {
      data = null
      return data;
    } else {
      return data;
    }
  }

  /**
   * Older records store survey identifiers with Gujarati numerals
   * (e.g. "2p૧૧"). The Survey/TP/FP pattern validators only accept ASCII
   * digits, so such a prefilled value would block Update with a
   * "please fill all required fields" error. Map Gujarati (and Devanagari)
   * digits to their English equivalents; everything else passes through.
   */
  toEnglishDigits(data: any): any {
    if (data === null || data === undefined || typeof data !== 'string') { return data; }
    const gujarati = '૦૧૨૩૪૫૬૭૮૯';
    const devanagari = '०१२३४५६७८९';
    return data.replace(/[૦-૯०-९]/g, (ch) => {
      const g = gujarati.indexOf(ch);
      if (g !== -1) { return String(g); }
      const d = devanagari.indexOf(ch);
      return d !== -1 ? String(d) : ch;
    });
  }

  /** renderData + Gujarati→English digit normalisation, for text survey identifiers. */
  renderIdentifier(data: any): any {
    return this.toEnglishDigits(this.renderData(data));
  }


  onPropVillageSelected(selected: any, field: any) {

    if (!selected) {

      // These controls only exist when the base doc type includes them
      // (Rural -> VillageID, Urban -> CityWardNo, Both -> both), so guard access.
      const villageCtrl = this.propDynamicNotice.get('VillageID');
      const wardCtrl = this.propDynamicNotice.get('CityWardNo');
      const villageVal = villageCtrl ? villageCtrl.value : null;
      const wardVal = wardCtrl ? wardCtrl.value : null;

      // for the fields removal village and ward only
      if (!villageVal && !wardVal) {
        this.selectedDistrictId = null;
        this.selectedDistrictName = null;
        this.selectedSourceField = null;
      }

      return;
    }


    const currentDistrictId = selected.DistrictId || null;
    const currentDistrictName = selected.DistrictName || null;



    if (!this.selectedDistrictId) {
      // First location selection establishes the district for this form.
      this.selectedDistrictId = currentDistrictId;
      this.selectedDistrictName = currentDistrictName;
      this.selectedSourceField = field.DBColumnName;
    } else if (this.selectedSourceField === field.DBColumnName) {
      // Re-selecting the SAME field (e.g. changing the Ward) — the user is just
      // correcting their choice, so move the lock to the new district instead of
      // rejecting it. (Fixes: a wrong Ward pick could never be changed.)
      this.selectedDistrictId = currentDistrictId;
      this.selectedDistrictName = currentDistrictName;
    } else if (this.selectedDistrictId != currentDistrictId) {
      // A DIFFERENT field (Village vs Ward) in a DIFFERENT district — Village and
      // Ward must stay in the same district. Reject and clear just this field.
      Swal.fire({
        title: 'Invalid Selection',
        text: `Please select data only from ${this.selectedDistrictName}`,
        type: 'warning'
      });

      this.propDynamicNotice.get(field.DBColumnName).setValue(null);

      return;
    }

    

    this.property.patchValue({
      DistrictID: selected.DistrictId || null,
      districtname: selected.DistrictName || null
    });


    

    if (selected.VillageId) {
      console.log("this is the village id from the:" + selected.VillageId);

      // NOTE: do NOT clear the ward fields here. A "Both" base document type
      // property can hold a village AND a ward simultaneously, so selecting a
      // village must preserve any ward already chosen (and vice versa).
      this.property.patchValue({
        villageid: selected.VillageId,
        villagename: selected.VillageName || null,
        TalukaID: selected.TalukaId || null,
        Talukaname: selected.TalukaName || null,
      });
      console.log("taluka is:" + selected.TalukaId + "taluka name is:" + selected.TalukaName);
    }


    

    if (selected.WardID) {

      this.property.patchValue({
        CityWardNo: selected.WardID,
        WardName: selected.WardName || null,

        CitySurveyOfficeID:
          selected.CitySurveyOfficeID || null,

        CitySurveyOfficeName:
          selected.CitySurveyOfficeName || null,
      });

      console.log("hello selected taluka id is:" + selected.TalukaId + "taluka name is:" + selected.TalukaName);
    }

    if (this.selectedLandType === 'ConstructedLand') {

      if (selected.WardID) {

        this.service
          .SocietylistUrban(selected.WardID)
          .subscribe((res: any) => {

            this.propDataList['BuildingName'] =
              res.data || [];
          });

      } else if (selected.VillageId) {

        this.service
          .Societylist(selected.VillageId)
          .subscribe((res: any) => {

            this.propDataList['BuildingName'] =
              res.data || [];
          });
      }
    }

    console.log("hello abnnjlnjkbhbhjbhkvdhbjkbvhjvk", selected.TalukaId, selected.talukaID, selected.TalukaName, selected.talukaname);
  }

  save() {
    console.log('kskcmmc', this.property.value);

    this.submitted = true;
    this.validation();
    this.isLoading = true;

    console.log('Form Values:', this.property);
    this.property.markAllAsTouched();
    this.propDynamicNotice.markAllAsTouched();

    if (!this.propStateID || !this.propBaseDocTypeID ||
      this.property.invalid ||
      this.propDynamicNotice.invalid ||
      this.showmsg) {
      this.isLoading = false;

      Swal.fire({
        title: "Validation Error",
        text: this.locationMissing
          ? "Please select a Village/Pincode or Ward — location cannot be blank."
          : "please fill all required fields",
        type: "warning"
      })
      return;
    }

    // Clear validators on old static property controls
    ['SurveyNo', 'TPNo', 'FPNo', 'SocietyName', 'BuildingNo', 'VillageID'].forEach((ctrlName) => {
      const c = this.property.get(ctrlName);
      if (c) {
        c.clearValidators();
        c.setErrors(null);
        c.updateValueAndValidity();
      }
    });

    if (this.property.valid && this.propDynamicNotice.valid && this.showmsg === false) {

      const dynValues = this.getPropDynamicFieldPayload();

      /* ── Urban (Ward) support — "safer variant" ────────────────────────────
         - Urban-only doc types (Ward field present, no Village field): store
           taluka & village as 0 (so the village-based Area-alert join can never
           collide), KEEP the real District, and store the ward in its own
           columns (WardID / CitySurveyOfficeID).
         - Rural: village/taluka/district real; ward columns null.
         - Both: everything real (village-based + ward).
         BaseDocumentType_Dynamic carries the StateBaseDocTypeID so the View
         screen and the Survey-alert matcher can tell Rural / Urban / Both.
         NOTE: in this form the `CityWardNo` control holds the WardID value. */
      const hasVillageField = !!this.propDynamicNotice.get('VillageID');
      const hasWardField = !!this.propDynamicNotice.get('CityWardNo');
      const isUrbanOnly = hasWardField && !hasVillageField;

      const wardId = hasWardField ? (this.property.value.CityWardNo || null) : null;
      const ctsId = hasWardField ? (this.property.value.CitySurveyOfficeID || null) : null;

      const finalData: any = {

        UserID: this.property.value.UserID,
        csrId: this.property.value.csrId,
        DistrictID: this.property.value.DistrictID,
        TalukaID: isUrbanOnly ? 0 : this.property.value.TalukaID,
        villageid: isUrbanOnly ? 0 : (dynValues['villageid'] || this.property.value.villageid || null),
        districtname: this.property.value.districtname || null,
        villagename: this.property.value.villagename || null,
        Talukaname: this.property.value.Talukaname || null,
        SurveyNo: dynValues['SurveyNo'] || null,
        TPNo: dynValues['TPNo'] || null,
        FPNo: dynValues['FPNo'] || null,
        Society: dynValues['Society'] || this.property.value.Society || null,
        SocietyName: dynValues['SocietyName'] || this.property.value.SocietyName || null,
        BuildingNo: dynValues['BuildingNo'] || null,


        LandType: this.selectedLandType,
        PropStateID: this.propStateID,
        PropBaseDocTypeID: this.propBaseDocTypeID,
        // Persist the base doc type on the subscription (Rural/Urban/Both marker).
        BaseDocumentType_Dynamic: this.propBaseDocTypeID || null,

        // Ward columns — populated only for Urban / Both.
        WardID: wardId,
        CityWardNo: wardId,
        WardName: hasWardField ? (this.property.value.WardName || null) : null,
        CitySurveyOfficeID: ctsId,
        CitySurveyOfficeName: hasWardField ? (this.property.value.CitySurveyOfficeName || null) : null,
      };


      if (hasWardField && dynValues['CityWardNo'] !== undefined && dynValues['CityWardNo'] !== null) {
        finalData['CityWardNo'] = dynValues['CityWardNo'];
        finalData['WardID'] = dynValues['CityWardNo'];
      }

      const handledKeys = [
        'villageid', 'SurveyNo', 'TPNo', 'FPNo',
        'Society', 'SocietyName', 'BuildingNo', 'CityWardNo'
      ];
      Object.keys(dynValues).forEach((key) => {
        if (!handledKeys.includes(key)) {
          finalData[key] = dynValues[key];
        }
      });

      console.log('FINAL PAYLOAD:', finalData);

      if (this.Type != 'edit') {
        this.service.AddProperty(finalData).subscribe(
          (res: any) => {
            this.submitted = false;
            if (res.status === 200) {
              Swal.fire({
                position: 'top-end',
                type: 'success',
                title: res.Message,
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.router.navigate(['/users/view-property']);
                this.isLoading = false;
              });
            } else {
              // 400 (business rule) or any other non-success status → show the
              // server message and STOP the loader (do not treat as success).
              this.isLoading = false;
              Swal.fire({
                position: 'top-end',
                text: res.Message || res.message || 'Could not add property.',
                type: 'info',
              });
            }
          },
          (err) => {
            // HTTP error (e.g. 500) — without this the loader used to spin forever.
            this.isLoading = false;
            this.submitted = false;
            Swal.fire({
              title: 'Error',
              text: (err && err.error && (err.error.message || err.error.Message)) || 'Could not add property. Please try again.',
              type: 'error',
            });
          }
        );

      } else {
        if (this.Editproperty) {
          this.service.editProperty(this.PropertyId, finalData).subscribe(
            (res: any) => {
              this.submitted = false;
              if (res.status === 200) {
                Swal.fire({
                  position: 'top-end',
                  type: 'success',
                  title: res.Message,
                  showConfirmButton: false,
                  timer: 1500,
                }).then(() => {
                  this.router.navigate(['/users/view-property']);
                  this.isLoading = false;
                });
              } else {
                this.isLoading = false;
                Swal.fire({
                  position: 'top-end',
                  text: res.Message || res.message || 'Could not update property.',
                  type: 'info',
                });
              }
            },
            (err) => {
              this.isLoading = false;
              this.submitted = false;
              Swal.fire({
                title: 'Error',
                text: (err && err.error && (err.error.message || err.error.Message)) || 'Could not update property. Please try again.',
                type: 'error',
              });
            }
          );
        } else {
          // Guard: nothing to submit → don't leave the loader spinning.
          this.isLoading = false;
        }
      }

    } else {
      this.isLoading = false;
      this.propDynamicNotice.markAllAsTouched();
    }
  }


}
